import client from '@/store/client'
import qs from 'query-string'
import { parseStringPromise } from 'xml2js'
import parseData from '../util/parsedata'

const createHeaders =  (headers) => {
  const allHeaders =  []
  headers.forEach( header => {
    allHeaders.push( { 
      text: header.text,
      sortable: false,
      value: header.value,
    })
  })
  return allHeaders
}

const getDefaultState = () => {
  return {
    siteID: '',
    siteCode: '',
    retailerWithNoPretailer: false,
    siteFilterResults: [],
    totalOnServer: -1,
    createSiteCode: '',
    siteDescription: '',
    selectedType: '',
    selectedPromocode: '0',
    siteCreated: {
      successful: false,
      newID: ''
    },    
    siteGroupTypes: [],
    promoChildTypes: [],
    tableHeaders: createHeaders([
      {
        text: 'Site ID',
        value: 'ID'
      },
      {
        text: 'Site Code',
        value: 'Code'
      },
      {
        text: 'Site Type Name',
        value: 'TypeID'
      },
    ])
  }
}

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    siteTypes: [],
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    RESET_NEW_SITE: ({commit}) => {
      commit('resetNewSite')
    },
    FIND_SITE: async function( {commit}, data ) {
      try{
        const dataReq = {
          ...this.getters['siteFilter/findSiteData'],
          recordIndex: data.page,
          RecordsPerPageCount: data.itemsPerPage,
          retailerID: data.retailerId
        }       
        const APIRes = await client.post('/v1/Site.asmx/FindSite', qs.stringify(dataReq))
        const response = await parseStringPromise(APIRes.data)
        commit('setSiteFilterResults', await parseData(APIRes.data))
        commit('setField', { key: 'totalOnServer', value: +response.content.collection[0].$.TotalRecordCount })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
    GET_PROMO_CHILD_TYPES: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetPromotionChildTypesByRetailerId', qs.stringify({ retailerID: this.state.retailer.retailerInfo.ID }))
        commit('setField', { key: 'promoChildTypes', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,      
        })            
      }
    },
    GET_SITE_TYPES: async function({ commit }){
      try {     
        const siteTypesAPI = await client.post('/v1/Lookup.asmx/GetSiteTypes', qs.stringify(this.getters['traceToken']))
        commit('setSiteTypes', await parseData(siteTypesAPI.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,      
        })            
      }
    },
    GET_PROMOCODES: async function({ commit }){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Data',
          subdetail: 'Please wait',
        })        
        const APIResults = await client.post('/v1/MerchantStoreGroup.asmx/GetPromotionCodesByRetailerID', qs.stringify(this.getters['siteFilter/getPromocodesData']))
        commit('setPromocodes', await parseData(APIResults.data))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Data Received',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,       
        })       
      }   
    },
    INSERT_SITE: async function({ commit }){
      try {
      this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Site',
          subdetail: 'Please wait',
        })        
        const APIResults = await client.post('/v1/Site.asmx/InsertSite', qs.stringify(this.getters['siteFilter/insertSiteData']))
        const parseResults = await parseStringPromise(APIResults.data)
        commit('setSiteCreated', parseResults.content.data[0].$.ID)
        this.dispatch('ui/SET_TOAST', { message: `New Site created with ID: ${ parseResults.content.data[0].$.ID }`, color: 'green', delay: 2500 })
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Site Created',
          subdetail: '',
        })
      }   
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Could not create site',
          subdetail: err.response.data,
        })       
      } 
    }
  },
  getters: {
    promoChildTypes: (state) => {
      return state.promoChildTypes.map( item => {
        return { text: item.PromotionChildTypeName, value: item.PromotionChildTypeID }
      })
    },
    siteTypeItems: (state) => {
      const eligibleSiteTypes =  state.siteTypes.filter( type => type.EligibleForRetailer == "true")
      return eligibleSiteTypes.map( type => {
        return { text: type.Name, value: type.ID }
      })
    },
    findSiteData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        IncludeRetailerSitesWithoutPRetailerAttachments: state.retailerWithNoPretailer,
        promotionCode: rootState.msgSearch.promoVersionCode,
        SiteID: state.siteID || 0,
        SiteCode: state.siteCode,
      }
    },
    getPromocodesData: (state, getters, rootState) => {
      return {
        retailerId: rootState.retailer.retailerInfo.ID,
        token: rootState.user.token
      }
    },
    insertSiteData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        promotionTypeID: state.selectedPromocode,
        description: state.siteDescription,
        typeID: state.selectedType,
        code: state.createSiteCode,
      }
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    resetNewSite: function(state) {
      state.createSiteCode = ''
      state.siteDescription = ''
      state.selectedType = ''
      state.selectedPromocode = '0'
      state.siteCreated = {
        successful: false,
        newID: ''
      }
    },
    setSiteFilterResults: function(state, data) {
      state.siteFilterResults = data
    },
    setSiteTypes: function(state, data) {
      state.siteTypes = data
    },
    setSiteGroupTypes: function(state, data) {
      state.siteGroupTypes = data
    },
    setSiteCreated: function(state, data){
      state.siteCreated.successful = true,
      state.siteCreated.newID = data
    }
  },
}
